import React, { Component } from "react";

import Base from "../../components/Base";
import Form from "./Form";

import api from "../../services/api";
import { Spin, Button, Modal, Alert } from "antd";

import "./styles.css";

export default class Importacao extends Component {
  state = {
    depart_selected: null,
    departamentos: [],
    error: null,
    loading: true,
    pipedrive_loading: false,
    pipedrive_token: null,
    form_users: null // Grid de usuários para distribuição de pastas
  };

  async componentDidMount() {
    /** Carrega os departamentos */
    await api
      .get("/departamentos/")
      .then(response => {
        this.setState({
          departamentos: response.data
        });
      })
      .catch(() => {
        this.setState({
          error: "Não foi possível obter os departamentos do sistema."
        });
      });

    /** Obtém o token do pipedrive */
    await api
      .get("/tokens/")
      .then(response => {
        const data = response.data;
        this.setState({
          pipedrive_token: data.pipedrive
        });
      })
      .catch(() => {
        this.setState({
          error: "Não foi possível consultar os tokens do sistema."
        });
      });

    this.setState({
      loading: false
    });
  }

  /** Obtém os users de determinado departamento e suas pastas */
  handleSelect = () => {
    const id = document.getElementById("departamentos").value;

    this.setState(
      {
        form_users: null
      },
      () => {
        if (id == 0) {
          Modal.error({
            title: "Erro",
            content: "Selecione um departamento!"
          });
          return;
        }

        this.setState({
          pipedrive_loading: true
        });

        const departamento = this.state.departamentos.find(obj => obj.id == id);

        if (departamento) {
          this.setState({
            form_users: (
              <Form
                users={departamento.users}
                pipedrive_token={this.state.pipedrive_token}
                departamento_id={id}
              />
            )
          });
        } else {
          Modal.error({
            title: "Erro",
            content: "Departamento inválido!"
          });
        }

        this.setState({
          pipedrive_loading: false
        });
      }
    );
  };

  render() {
    let component = null;

    if (this.state.error) {
      component = (
        <div>
          <Alert type="error" message={this.state.error} />
        </div>
      );
    } else if (this.state.loading) {
      component = (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Spin />
        </div>
      );
    } else {
      /** Select de departamento */
      component = (
        <div className="imp__departamentos">
          <div className="title">Selecione o departamento:</div>
          <div className="d-flex">
            <select className="ant-input" id="departamentos">
              <option value={0}>Selecione</option>
              {this.state.departamentos.map(obj => {
                return (
                  <option value={obj.id} key={obj.id}>
                    {obj.nome}
                  </option>
                );
              })}
            </select>
            <Button
              type="primary"
              onClick={this.handleSelect}
              style={{ marginLeft: "10px" }}
              loading={this.state.pipedrive_loading}
            >
              Selecionar
            </Button>
          </div>
        </div>
      );
    }

    return (
      <Base title="Importação Pipedrive">
        {component}
        <hr />
        {this.state.form_users}
      </Base>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Importacao/index.js